import { Injectable } from '@angular/core';

interface HeapApi {
  clearEventProperties(): void;
  identify(email: string): void;
  track(event: string, options?: Record<string, unknown>): void;
}

declare global {
  interface Window {
    heap?: HeapApi;
  }
}

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  constructor(private window: Window) {}

  private eventNamespace = 'Nutrition Calculator';

  private get _heap(): HeapApi {
    return this.window.heap;
  }

  clearEventProperties(): void {
    this._heap.clearEventProperties();
  }

  identify(email: string): void {
    this._heap.identify(email);
  }

  track(event: string, options: Record<string, unknown> = {}): void {
    const namespacedEvent = `${this.eventNamespace} - ${event}`;

    this._heap.track(namespacedEvent, options);
  }
}
